"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18nVue = exports.trans_choice = exports.reset = exports.getActiveLanguage = exports.transChoice = exports.trans = exports.loadLanguageAsync = void 0;
const vue_1 = require("vue");
const pluralization_1 = require("./pluralization");
/**
 * Resolves the lang location, on a Laravel App.
 */
const defaultResolve = (lang) => {
    return import(`../../../resources/lang/${lang}.json`);
};
/**
 * The default options, for the plugin.
 */
const DEFAULT_OPTIONS = {
    lang: document.documentElement.lang || 'en',
    resolve: defaultResolve
};
/**
 * Stores the current options.
 */
let options = DEFAULT_OPTIONS;
/**
 * Stores the loaded languages.
 */
let loaded = [];
/**
 * The active messages to use.
 */
const activeMessages = (0, vue_1.reactive)({});
/**
 * Loads the language file.
 */
function loadLanguageAsync(lang) {
    const loadedLang = loaded.find((row) => row.lang === lang);
    if (loadedLang) {
        return Promise.resolve(setLanguage(loadedLang));
    }
    return options
        .resolve(lang)
        .then(({ default: messages }) => {
        const data = { lang, messages };
        loaded.push(data);
        return setLanguage(data);
    })
        .catch((err) => {
        throw new TypeError(`Cannot load lang: ${lang} file: ${err.message}`);
    });
}
exports.loadLanguageAsync = loadLanguageAsync;
/**
 * Get the translation for the given key.
 */
function trans(key, replacements = {}) {
    if (!activeMessages[key]) {
        activeMessages[key] = key;
    }
    return makeReplacements(activeMessages[key], replacements);
}
exports.trans = trans;
/**
 * Translates the given message based on a count.
 */
function transChoice(key, number, replacements = {}) {
    const message = trans(key, replacements);
    replacements.count = number.toString();
    return makeReplacements((0, pluralization_1.choose)(message, number, options.lang), replacements);
}
exports.transChoice = transChoice;
/**
 * Returns the current active language.
 */
function getActiveLanguage() {
    return options.lang;
}
exports.getActiveLanguage = getActiveLanguage;
/**
 * Sets the language messages to the activeMessages.
 */
function setLanguage({ lang, messages }) {
    document.querySelector('html').setAttribute('lang', lang);
    options.lang = lang;
    for (const [key, value] of Object.entries(messages)) {
        activeMessages[key] = value;
    }
    for (const [key] of Object.entries(activeMessages)) {
        if (!messages[key]) {
            activeMessages[key] = null;
        }
    }
    return lang;
}
/**
 * Make the place-holder replacements on a line.
 */
function makeReplacements(message, replacements) {
    const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);
    Object.entries(replacements || []).forEach(([key, value]) => {
        value = value.toString();
        message = message
            .replace(`:${key}`, value)
            .replace(`:${key.toUpperCase()}`, value.toUpperCase())
            .replace(`:${capitalize(key)}`, capitalize(value));
    });
    return message;
}
/**
 * Resets all the data stored in memory.
 */
const reset = () => {
    loaded = [];
    options = DEFAULT_OPTIONS;
    for (const [key] of Object.entries(activeMessages)) {
        activeMessages[key] = null;
    }
};
exports.reset = reset;
/**
 * Alias to `transChoice` to mimic the same function name from Laravel Framework.
 */
exports.trans_choice = transChoice;
/**
 * The Vue Plugin. to be used on your Vue app like this: `app.use(i18nVue)`
 */
exports.i18nVue = {
    install: (app, currentOptions = {}) => {
        options = Object.assign(Object.assign({}, options), currentOptions);
        app.config.globalProperties.$t = (key, replacements) => trans(key, replacements);
        app.config.globalProperties.$tChoice = (key, number, replacements) => transChoice(key, number, replacements);
        loadLanguageAsync(options.lang);
    }
};
//# sourceMappingURL=index.js.map